module.exports = __webpack_public_path__ + "img/portrait-082.b0597a7c.jpg";